export const DOSTAVISTA_PARAMETER_ERROR_DESCRIPTIONS: Record<string, string> = {
  required: 'Не передан обязательный параметр.',
  unknown: 'Переданный параметр не поддерживается в API.',
  invalid_list: 'Некорректное значение поля list.',
  invalid_object: 'Некорректное значение поля object.',
  invalid_boolean: 'Некорректное значение поля boolean.',
  invalid_date: 'Некорректное значение поля date.',
  invalid_date_format: 'Некорректный формат datetime.',
  invalid_float: 'Некорректное значение поля float.',
  invalid_integer: 'Некорректное значение поля integer.',
  invalid_string: 'Некорректное значение поля string.',
  invalid_phone: 'Некорректный номер телефона.',
  invalid_region: 'Адрес не входит в зону доставки региона.',
  different_regions: 'Адреса заказа из разных регионов.',
  address_not_found: 'Не удалось геокодировать адрес.',
  cannot_be_past: 'Дата и время не могут быть в прошлом.',
};
